import React, { useState, useEffect} from "react";
import { BrowserRouter, useHistory } from "react-router-dom";
import axios from "axios";
// Material UI
import {
	Container,
	TextField,
	InputAdornment,
	Button,
	Typography,
} from "@material-ui/core";
import AccountCircleTwoToneIcon from "@material-ui/icons/AccountCircleTwoTone";
import LockTwoToneIcon from "@material-ui/icons/LockTwoTone";

//MessageBox
import LoginMessageBox from "../../components/MessageBox/LoginMessageBox";

//Cookie setter/getter
import {add_cookies, delete_all_cookies} from "../../components/Cookies/Cookies";

// Stylesheet
import "./Login.scss";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const ChangePassword = () => {
	const location = useLocation();
	const {username,istemp } = location.state || {};
	// const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [newPassword, setNewPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');

	const [userData, setUserData] = useState(false);

	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(true);

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("empty");
	const isMismatchNew = newPassword && newPassword !== password;
	const isMismatchConfirm = confirmPassword && confirmPassword !== newPassword;
	const allPasswordsMatch =
	newPassword && confirmPassword &&
	newPassword === confirmPassword;

	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	let history = useHistory();
	const isPasswordValid = (pw) => {
		return (
		pw.length >= 8 &&
		/[A-Z]/.test(pw) &&
		/[a-z]/.test(pw) &&
		/[0-9]/.test(pw) &&
		/[!@#$%^&*(),.?":{}|<>]/.test(pw)
		);
		};

	useEffect(() => {
	const allFilled =
		username !== "" &&
		password !== "" &&
		confirmPassword !== "" &&
		newPassword !== "";

	const allValid = isPasswordValid(newPassword) && allPasswordsMatch;

		if (allFilled && allValid) {
		setBtnDisabled(false);
		} else {
		setBtnDisabled(true);
		}
	}, [username, password, confirmPassword, newPassword, allPasswordsMatch]);

	useEffect(()=> {
		if(userData){ //if state array not empty
			//1.5 = 1 hour and 30minutes == 90mins cookie lifespan
      add_cookies("user_id", userData.user_id, 1.5);
      add_cookies("userrole", userData.get_position_access.position, 1.5);
      add_cookies("fullname", userData.name, 1.5);
      add_cookies("branchidno", userData.idno, 1.5);
      add_cookies(
        "main.nav.access",
        JSON.stringify(userData.get_position_access.access_nav),
        1.5
      );
      add_cookies(
        "content.nav.access",
        JSON.stringify(userData.get_position_access.access_content_nav),
        1.5
      );
      add_cookies("position_id", JSON.stringify(userData.position_id), 1.5);
      add_cookies("curcode", userData.curcode, 1.5);
      add_cookies("branchtype", userData.is_bc, 1.5);
			//console.log(JSON.stringify(userData.get_position_access.access_content_nav)));
			//console.log('cookies added');
		}
	}, [userData]);

	const handleKeyPress = (event) => {
		if(event.key === 'Enter'){
			change_password();
		}
	  }

	const change_password = async () => {
		setBtnDisabled(true); // disable button to avoid multiple saves
		const formData = new FormData();
		formData.append("username", username);
		formData.append("password", confirmPassword);
		formData.append("oldpassword", password);
		formData.append("is_temp", istemp);

		await axios.post(process.env.REACT_APP_API_URL+'change_password', formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
				// 'Access-Control-Allow-Origin': process.env.REACT_APP_API_URL,
			}
			}).then(function (res) {
				// console.log(res.data);
				if(res.data.status !== 1){
					let message = res.data.message ? res.data.message  : "Invalid password"; //fallback value incase message property not found
					setShowMsgBox(true);
					setMsg(message);
					setMsgType("warning");
					setTimeout(() => {
						setShowMsgBox(false);
						setBtnDisabled(false); 
					}, 2000)
				}else{ 	//success, status == 1
					// console.log('43',res.data);
					// console.log('03',res.data.data);
					delete_all_cookies();
					localStorage.clear();
					sessionStorage.clear();


					add_cookies('username', username, 1.5);
					add_cookies('country', res.data.data.country, 1.5);
					setUserData(res.data.data);
					setShowMsgBox(true);
					setMsg("Succesfully Updated password");
					setMsgType("success");
					setTimeout(() => {
						setShowMsgBox(false);
						setBtnDisabled(false); 
						history.push("/dashboard");
					}, 2000)
				}
		  	}).catch(function (error) {
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
	}

				const requirements = [
			{
			label: "Minimum 8 characters",
			test: (pw) => pw.length >= 8,
			},
			{
			label: "At least 1 uppercase letter",
			test: (pw) => /[A-Z]/.test(pw),
			},
			{
			label: "At least 1 lowercase letter",
			test: (pw) => /[a-z]/.test(pw),
			},
			{
			label: "At least 1 number",
			test: (pw) => /[0-9]/.test(pw),
			},
			{
			label: "At least 1 symbol (e.g., !@#$%^&*)",
			test: (pw) => /[!@#$%^&*(),.?":{}|<>]/.test(pw),
			},
			];

	return (
	
				<div className="banner">
			<div className="login">
				<LoginMessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<div className="login-fields">
					{/* <LoginMessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/> */}
					<form action="" autoComplete="off" className="login-form" onKeyPress={handleKeyPress}>
						<div className="login-field-container login-title">
							{/* <LoginMessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/> */}
								<div className="login-logo-container">
									<div className="login-logo">
									<img src={require('../../../src/logo.png')} alt=""  style={{width:"40px"}}/>
									</div>
									<Typography variant="h6" style={{color:"#339933!important"}}>JC Branches</Typography>
								</div>
							<Typography className="logo-text">
							Hello, the system detected that your password is {istemp == 10 ?'temporary':'outdated'}. To proceed, please update your password.
							<br />
							<br />
							<strong>New password requirements:</strong>
								<ul style={{ marginTop: "10px", paddingLeft: "20px" }}>
								{requirements.map((req, idx) => (
								<li
								key={idx}
								style={{
								color: req.test(newPassword) ? "green" : "red",
								}}
								>
								{req.label}
								</li>
								))}
							</ul>
							</Typography>
						</div>
						<div className="login-field-container">
							<TextField
								className="login-field"
								id="input-with-icon-textfield"
								variant="outlined"
								type="password"
								label="Current Password"
								value={password}
								onChange={(e)=>{setPassword(e.target.value)}}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<LockTwoToneIcon />
										</InputAdornment>
									),
								}}
							/>
						</div>
						<div className="login-field-container">
							<TextField
								className="login-field"
								id="input-with-icon-textfield"
								variant="outlined"
								label="New Password"
								type="password"
								value={newPassword}
								onChange={(e)=>{setNewPassword(e.target.value)}}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<LockTwoToneIcon />
										</InputAdornment>
									),
								}}
							/>
						</div>
						<div className="login-field-container">
							<TextField
								className="login-field"
								id="input-with-icon-textfield"
								variant="outlined"
								label="Confirm Password"
								type="password"
								value={confirmPassword}
								onChange={(e)=>{setConfirmPassword(e.target.value)}}
								error={isMismatchConfirm}
								helperText={
									confirmPassword && confirmPassword !== newPassword
									  ? "Confrim Password do not match"
									  : ""
								      }
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<LockTwoToneIcon />
										</InputAdornment>
									),
								}}
							/>
						</div>
						<div className="login-field-container login-field-button">
								<Button disabled={btnDisabled} variant="contained" color="primary" onClick={()=>{change_password()}}>
									Save New Password 								</Button>
						</div>
					</form>
				</div>
				{/* <div className="login-graphic">
					<img
						src="/images/login.svg"
						alt=""
						className="login-image"
					/>
				</div> */}
			</div>
			</div>

	);
};

export default ChangePassword;
